import { fork } from 'redux-saga/effects';

import { saveInsurancesData } from './save-insurances-data';
import { uploadInsuranceCard } from './upload-insurance-card';
import { saveToDoInsurancesData } from './save-to-do-insurances-data';
import { uploadMainInsuranceCard } from './upload-main-insurance-card';
import { downloadPatientInsuranceData } from './download-patient-insurances-data';
import { runManualEligibilityActivation } from './run-manual-eligibility-activation';
import { downloadToDoTaskInsurancesData } from './download-to-do-task-insurances-data';
import { clearManageInsuranceRelatedData } from './clear-manage-insurance-related-data';

import { watcher as updatePatientInsuranceWatcher } from '../requests/update-patient-insurance';
import { watcher as deletePatientInsuranceWatcher } from '../requests/delete-patient-insurance';
import { watcher as createPatientInsuranceWatcher } from '../requests/create-patient-insurance';
import { watcher as getPatientInsurancesListWatcher } from '../requests/get-patient-insurances-list';
import { watcher as checkUploadedInsuranceCardOCRWatcher } from '../requests/check-uploaded-insurance-card-ocr';
import { watcher as exportPatientInsuranceEhrDocumentsWatcher } from '../requests/export-patient-insurance-ehr-documents';

export default function* manageInsurancesRootSaga() {
  yield fork(saveInsurancesData);
  yield fork(uploadInsuranceCard);
  yield fork(saveToDoInsurancesData);
  yield fork(uploadMainInsuranceCard);
  yield fork(downloadPatientInsuranceData);
  yield fork(runManualEligibilityActivation);
  yield fork(clearManageInsuranceRelatedData);
  yield fork(downloadToDoTaskInsurancesData);

  yield fork(updatePatientInsuranceWatcher);
  yield fork(deletePatientInsuranceWatcher);
  yield fork(createPatientInsuranceWatcher);
  yield fork(getPatientInsurancesListWatcher);
  yield fork(checkUploadedInsuranceCardOCRWatcher);
  yield fork(exportPatientInsuranceEhrDocumentsWatcher);
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/index.js